import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
const books = [{
  number: 1,
  title: 'PODSTAWY',
  subtitle: 'U6 — U7',
  promise: 'Zbuduj mocne fundamenty u każdego zawodnika. Gotowe plany treningowe dla poziomu początkującego — do użycia od pierwszego dnia.',
  features: ['Makroplan 40 tygodni', 'Ćwiczenia adaptacyjne i koordynacyjne', 'Gry i zabawy z piłką', 'Karty oceny zawodnika', 'Listy obecności', 'List dla rodziców']
}, {
  number: 2,
  title: 'TECHNIKA',
  subtitle: 'U8 — U9',
  promise: 'Specjalistyczne ćwiczenia z diagramami boiska które systematycznie rozwijają umiejętności techniczne zawodników.',
  features: ['Prowadzenie i kontrola piłki', 'Podanie i przyjęcie', 'Zwody i dryblingi', 'Strzał na bramkę', 'Gra 1v1 i 2v2', 'Karty oceny technicznej']
}, {
  number: 3,
  title: 'INTELIGENCJA',
  subtitle: 'U10 — U11',
  promise: 'Gotowe plany treningowe rozwijające inteligencję taktyczną — obserwuj, myśl, decyduj, działaj.',
  features: ['Podejmowanie decyzji pod presją', 'Przejścia atak-obrona', 'Ćwiczenia kombinacyjne', 'Gra pozycyjna', 'Schematy taktyczne', 'Karty oceny taktycznej']
}, {
  number: 4,
  title: 'ZESPÓŁ',
  subtitle: 'U12 — U13',
  promise: 'Ucz taktyki piłkarskiej jak profesjonalista z jasnymi diagramami i planami treningowymi.',
  features: ['Systemy gry i ustawienia', 'Taktyka obronna i ofensywna', 'Stałe fragmenty gry', 'Pressing i kontratak', 'Plany meczowe', 'Karty oceny zespołowej']
}, {
  number: 5,
  title: 'ATLAS TRENERA',
  subtitle: 'Wszystkie poziomy',
  promise: 'Kompletny kompendium ćwiczeń, schematów i szablonów dla wszystkich grup wiekowych w jednym miejscu.',
  features: ['Biblioteka 200+ ćwiczeń', 'Schematy boisk', 'Szablony planów treningowych', 'Diagramy taktyczne', 'Słownik pojęć taktycznych', 'Indeks ćwiczeń według kategorii']
}, {
  number: 6,
  title: 'ADMINISTRACJA',
  subtitle: 'Zarządzanie i dokumentacja',
  promise: 'Roczny system planowania dla trenera obejmujący wszystkie poziomy, wszystkie miesiące, wszystkie tygodnie.',
  features: ['Szablony komunikacji z rodzicami', 'Karty oceny indywidualnej', 'Listy obecności', 'Raport miesięczny', 'Psychologia pracy z młodym zawodnikiem', 'Dokumentacja klubowa']
}];
export function SixBooks() {
  return <section className="w-full bg-navy-primary py-12 md:py-20 px-4 md:px-6" data-id="element-206">
      <div className="max-w-6xl mx-auto" data-id="element-207">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-12" data-id="element-208">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-display font-bold text-white mb-3 md:mb-4" data-id="element-209">
            6 tomów kompletnego systemu
          </h2>
          <p className="text-base md:text-lg text-gray-300 max-w-2xl mx-auto" data-id="element-210">
            Cyfrowe narzędzia w formacie PDF — gotowe do druku lub wyświetlenia
            na tablecie od dziś
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8" data-id="element-211">
          {books.map((book, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} whileHover={{
          y: -6
        }} className="bg-white rounded-2xl overflow-hidden shadow-lg flex flex-col h-full border-l-4 border-gold-accent" data-id="element-212">
              <div className="bg-navy-dark p-5 md:p-6 relative" data-id="element-213">
                <div className="absolute top-4 right-4 w-10 h-10 md:w-12 md:h-12 bg-gold-accent/20 rounded-full flex items-center justify-center border border-gold-accent/30" data-id="element-214">
                  <span className="text-xl md:text-2xl font-bold text-gold-accent" data-id="element-215">
                    {book.number}
                  </span>
                </div>
                <BookOpen className="w-8 h-8 md:w-10 md:h-10 text-gold-accent mb-3 md:mb-4" data-id="element-216" />
                <h3 className="text-lg md:text-xl font-display font-bold text-white" data-id="element-217">
                  TOM {book.number} — {book.title}
                </h3>
                <p className="text-gold-accent font-medium mt-1" data-id="element-218">
                  {book.subtitle}
                </p>
              </div>
              <div className="p-5 md:p-6 flex-grow flex flex-col" data-id="element-219">
                <p className="text-sm md:text-base text-gray-700 leading-relaxed mb-4" data-id="element-220">
                  {book.promise}
                </p>
                <div className="mt-auto" data-id="element-221">
                  <p className="font-bold text-navy-primary text-sm mb-2" data-id="element-222">
                    Zawiera:
                  </p>
                  <ul className="text-sm text-gray-600 space-y-1" data-id="element-223">
                    {book.features.map((feature, i) => <li key={i} className="flex items-start gap-2" data-id="element-224">
                        <span className="text-gold-accent mt-0.5" data-id="element-225">•</span>
                        <span data-id="element-226">{feature}</span>
                      </li>)}
                  </ul>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}